import { useQuery } from '@tanstack/react-query';

import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import axiosClient from '@/shared/lib/axios';

/*************************************** general printing orders ********************************************** */

/*********************************** list of orders *********************************** */
const getPrintingOrdersList = async (
  params: IPrintingOrders.IGetPrintingOrdersListSchema
): Promise<IPrintingOrders.IGetPrintingOrdersListResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/printing-orders/list',
    {
      params,
    }
  );
  return data;
};

export const useGetPrintingOrdersList = (
  params: IPrintingOrders.IGetPrintingOrdersListSchema
) => {
  return useQuery(
    ['getPrintingOrdersList', params],
    () => getPrintingOrdersList(params),
    {
      enabled: Boolean(params.entityId) && Boolean(params.date),
    }
  );
};

/***********************************  orders details  *********************************** */
const getPrintingOrdersListDetails = async (
  params: IPrintingOrders.IGetPrintingOrdersListDetailsSchema
): Promise<IPrintingOrders.IGetPrintingOrdersListDetailsResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/printing-orders',
    {
      params,
    }
  );
  return data;
};

export const useGetPrintingOrdersListDetails = (
  params: IPrintingOrders.IGetPrintingOrdersListDetailsSchema
) => {
  return useQuery(
    ['getPrintingOrdersListDetails', params],
    () => getPrintingOrdersListDetails(params),
    {
      enabled:
        Boolean(params.entityId) &&
        Boolean(params.date) &&
        Boolean(params.userId),
    }
  );
};
/************************************************************packhouse **************************** */
/*********************************** list of orders *********************************** */
const getSuppliersOrders = async (
  params: IPrintingOrders.IGetSuppliersOrdersSchema
): Promise<IPrintingOrders.IGetSuppliersOrdersResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/packhouse/printing-orders/list',
    {
      params,
    }
  );
  return data;
};

export const useGetSupervisorsOrders = (
  params: IPrintingOrders.IGetSuppliersOrdersSchema
) => {
  return useQuery(
    ['getSuppliersOrders', params],
    () => getSuppliersOrders(params),
    {
      enabled: Boolean(params.entityId) && Boolean(params.date),
    }
  );
};

/*********************************** supplier orders  *********************************** */
const getSupplierOrdersDetails = async (
  params: IPrintingOrders.IGetSupplierOrdersDetailsSchema
): Promise<IPrintingOrders.IGetSupplierOrdersDetailsResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/packhouse/printing-orders',
    {
      params,
    }
  );
  return data;
};

export const useGetSupplierOrdersDetails = (
  params: IPrintingOrders.IGetSupplierOrdersDetailsSchema
) => {
  return useQuery(
    ['getSupplierOrdersDetails', params],
    () => getSupplierOrdersDetails(params),
    {
      enabled:
        Boolean(params.entityId) &&
        Boolean(params.date) &&
        Boolean(params.userId),
    }
  );
};
